export const ModalSizes = ['sm', 'md', 'lg'] as const
export type ModalSize = (typeof ModalSizes)[number]
